import { render, staticRenderFns } from "./WidgetModal.vue?vue&type=template&id=63663ea6&scoped=true&"
import script from "./WidgetModal.vue?vue&type=script&lang=js&"
export * from "./WidgetModal.vue?vue&type=script&lang=js&"
import style0 from "./WidgetModal.vue?vue&type=style&index=0&id=63663ea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63663ea6",
  null
  
)

export default component.exports